module.exports = __webpack_public_path__ + "static/media/bars2-and-notes.b311368c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bars2-and-notes.svg
// module id = 107
// module chunks = 0